import { Component, OnInit } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { CustomField } from '@classes/bizzmine/custom-field';
import { ProjectInfo } from '@classes/bizzmine/project-info';
import { AddUser } from '@classes/user/userAdd';
import { environment } from '@environments/environment';
import { AuthService } from '@services/auth/auth.service';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base';
import { UserService } from '@services/user/user.service';
import { cpuUsage } from 'process';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss'],
})
export class HelpComponent extends SubscriptionBaseComponent implements OnInit {
  cryptedUrl: SafeResourceUrl;
  isLoading = true;
  user: AddUser;

  constructor(private userService: UserService) {
    super();
  }

  ngOnInit(): void {
    this.initBizzMine();
  }

  private initBizzMine(): void {
    this.getUser();
    this.subscription.add(
      this.userService.clientChangedSubject.subscribe(() => {
        this.isLoading = true;
        this.getUser();
      })
    );
  }

  private getUser(): void {
    this.userService.getCurrentUser().subscribe((us) => {
      this.user = us;
      this.cryptedUrl = this.createUrl();
      this.isLoading = false;
    });
  }

  private createUrl(lang: string = 'EN'): SafeResourceUrl {
    const customFields: CustomField[] = [
      {
        value: this.user.client.name,
        id: environment.customFieldClientSmartWaste,
      },
    ];
    const projectInfo = new ProjectInfo(
      environment.bizzmineApiKey,
      this.user.username,
      environment.bizzmineProjectName,
      lang,
      customFields
    );
    return `${environment.bizzmineUrl}${btoa(
      unescape(encodeURIComponent(JSON.stringify(projectInfo)))
    )}`;
  }
}
